import { Component, OnDestroy, OnInit } from '@angular/core';
import { MainDataService } from 'app/services/main-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-address-manage-hint',
  templateUrl: './address-manage-hint.component.html',
  styleUrls: ['./address-manage-hint.component.css']
})
export class AddressManageHintComponent implements OnInit, OnDestroy {

	showHint: boolean;
	message: string;

	private addressManageHintSub: Subscription;
	constructor(
		private mainDataService: MainDataService
	) { }

	ngOnInit() {
		this.addressManageHintSub = this.mainDataService.addressManageHintBS.subscribe(data => {
			if (data) {
				this.showHint = true;
				if (data.hasOwnProperty('message')) {
					this.message = data.message;
				}
			} else {
				this.showHint = false;
			}
		})
	}
	ngOnDestroy(): void {
		this.addressManageHintSub.unsubscribe();
	}
}
